export default __webpack_public_path__ + "static/media/percent.b197e54c.svg";